import React from 'react'
import { Helmet } from 'react-helmet'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import withProps from 'recompose/withProps'

import BOOK_EOT from 'public/assets/fonts/circular/circular-std-book.eot'
import BOOK_WOFF from 'public/assets/fonts/circular/circular-std-book-adjusted.woff'
import BOOK_TTF from 'public/assets/fonts/circular/circular-std-book.ttf'
import BOOK_SVG from 'public/assets/fonts/circular/circular-std-book.svg'

import MEDIUM_EOT from 'public/assets/fonts/circular/circular-std-medium.eot'
import MEDIUM_WOFF from 'public/assets/fonts/circular/circular-std-medium.woff'
import MEDIUM_TTF from 'public/assets/fonts/circular/circular-std-medium.ttf'
import MEDIUM_SVG from 'public/assets/fonts/circular/circular-std-medium.svg'

import BOLD_EOT from 'public/assets/fonts/circular/circular-std-bold.eot'
import BOLD_WOFF from 'public/assets/fonts/circular/circular-std-bold.woff'
import BOLD_TTF from 'public/assets/fonts/circular/circular-std-bold.ttf'
import BOLD_SVG from 'public/assets/fonts/circular/circular-std-bold.svg'

import BLACK_EOT from 'public/assets/fonts/circular/circular-std-black.eot'
import BLACK_WOFF from 'public/assets/fonts/circular/circular-std-black.woff'
import BLACK_TTF from 'public/assets/fonts/circular/circular-std-black.ttf'
import BLACK_SVG from 'public/assets/fonts/circular/circular-std-black.svg'

const props = withProps(_ => ({
    defaultFontFace: `
        @font-face {
            font-family: "Circular Std Book";
            font-style: normal;
            font-weight: 400;
            src: url('${BOOK_EOT}') format('embedded-opentype'),
            url('${BOOK_WOFF}') format('woff'),
            url('${BOOK_TTF}')format('truetype'),
            url('${BOOK_SVG}') format('svg');
        }

        /* Circular Std Medium */

        @font-face {
            font-family: "Circular Std Book";
            font-style: normal;
            font-weight: 500;
            src: url('${MEDIUM_EOT}') format('embedded-opentype'),
            url('${MEDIUM_WOFF}') format('woff'),
            url('${MEDIUM_TTF}')format('truetype'),
            url('${MEDIUM_SVG}') format('svg');
        }

        /* Circular Std Bold */

        @font-face {
            font-family: "Circular Std Book";
            font-style: normal;
            font-weight: bold;
            src: url('${BOLD_EOT}') format('embedded-opentype'),
            url('${BOLD_WOFF}') format('woff'),
            url('${BOLD_TTF}')format('truetype'),
            url('${BOLD_SVG}') format('svg');
        }

        /* Circular Std Black */

        @font-face {
            font-family: "Circular Std Book";
            font-style: normal;
            font-weight: 900;
            src: url('${BLACK_EOT}') format('embedded-opentype'),
            url('${BLACK_WOFF}') format('woff'),
            url('${BLACK_TTF}')format('truetype'),
            url('${BLACK_SVG}') format('svg');
        }
    `,
}))

const FontFace = ({ fontFace, defaultFontFace }) => (
    <Helmet>
        <style>{fontFace ? fontFace : defaultFontFace}</style>
    </Helmet>
)

export default compose(
    props,
    pure
)(FontFace)
